<template>
  <div>
    <v-overlay :z-index="5000" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" max-width="700px">
      <v-card flat tile>
        <v-toolbar dense flat color="white" id="Top_Scroll">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">edit</v-icon>신청사항 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <v-toolbar dense flat color="white">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            신청자 정보
          </v-card-subtitle>
        </v-toolbar>
        <v-card class="ma-4 mt-0" tile outlined>
          <v-card-text class="mt-2 mb-2">
            <v-row align="center">
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.CustomNm"  label="신청자" dense disabled persistent-placeholder hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.CustomNickId" label="ID" dense disabled persistent-placeholder hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.LevNm" label="직급" dense disabled persistent-placeholder hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.Tel" label="휴대전화" dense disabled persistent-placeholder hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-if="CustomInfo.Local == 'Y'" v-model="CustomInfo.CorpNmKor" label="업체명" dense disabled persistent-placeholder hide-details></v-text-field>
                <v-text-field v-else v-model="CustomInfo.CorpNmEng" label="업체명" dense disabled persistent-placeholder hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="CustomInfo.National" label="국적" dense disabled persistent-placeholder hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-toolbar dense flat color="white" class="hidden-sm-and-down">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            변경할 업체
          </v-card-subtitle>
          <div class="ml-2 text-caption grey--text text--darken-2 font-weight-bold">
            <div>*사업자번호가 동일한 경우에는 협력업체 관리자를 통해 '업체정보 정정' 신청을 바랍니다.</div>
          </div>
        </v-toolbar>
        <v-toolbar dense flat color="white" class="hidden-md-and-up mb-4">
          <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
            변경할 업체
            <div class="mb-2 pb-0 pt-0 text-caption grey--text text--darken-2 font-weight-bold text-justify">
              <div>*사업자번호가 동일한 경우에는 협력업체 관리자를 통해 '업체정보 정정' 신청을 바랍니다.</div>
            </div>
          </v-card-subtitle>
        </v-toolbar>
        <v-card outlined tile class="ma-4 mb-0 mt-0 essetial_card">
          <v-card-text class="mt-2 mb-2">
            <v-row align="center">
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="cCorpNm" @keyup="editedItem.cNewCorpId = ''" @keyup.enter="SearchCorpDialog()" @click:append="SearchCorpDialog()" append-icon="search" dense persistent-placeholder ref="cCorpNmRef" hide-details>
                  <template v-slot:label>
                    업체명<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="editedItem.cChangeReason" dense auto-grow rows="1" persistent-placeholder hide-details>
                  <template v-slot:label>
                    변경 사유<strong class="red--text">*</strong><br>
                    (상세히)<br>
                    100자 이내
                  </template>                
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="d-flex flex-wrap ma-4 essetial_card" flat outlined tile>
          <v-card width="170" flat class="ml-4 mr-4 pa-4 essetial_card">
            <v-img
              :aspect-ratio="2/1"
              :src="sNowPath"
              contain
              style="height:100px"
              max-height="150px"
            ></v-img>
            <v-file-input
              v-on:change="onSelFile(NowSelFile)"
              v-model="NowSelFile"
              class="mt-2"
              accept="image/png"
              :placeholder="editedItem.cFileNm"
              dense
            ></v-file-input>
          </v-card>
          <v-card class="essetial_card" flat>
            <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
              <p>재직증명서<span class="red--text">*</span></p>
            </v-card-subtitle>
            <v-card-text class="text-caption">
              JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
              다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
              (첨부 할 수 있는 파일의 최대 크기는 10MB 까지 입니다)
            </v-card-text>
          </v-card>
        </v-card>

        <!-- <v-card class="d-flex ma-4" tile outlined>
          <v-card height="170" flat class="ml-4 mr-4 pa-4">
            <v-img
              :aspect-ratio="1/1"
              :src="sNowPath"
              contain
              style="height:100px"
              max-width="150px"
              max-height="150px"
            ></v-img>
            <v-file-input
              v-on:change="onSelFile(NowSelFile)"
              v-model="NowSelFile"
              class="mt-2"
              accept="image/png"
              :placeholder="editedItem.cFileNm"
              dense
            ></v-file-input>
          </v-card>
          <v-card flat>
            <v-card-subtitle class="grey--text text--darken-2 font-weight-bold pb-1">
              <p>재직증명서</p>
            </v-card-subtitle>
            <v-card-text class="text-caption">
              JPG,JPEG,PNG,GIF파일만 첨부하세요.<br>
              (첨부 할 수 있는 파일의 최대 크기는 10MB까지 입니다)<br>
              다시 첨부하면 이전 첨부파일은 삭제됩니다.<br>
            </v-card-text>
          </v-card>
        </v-card> -->

        <div align="right" class="pa-4">
          <v-divider class="mb-2"></v-divider>
          <v-btn @click="dialog = false;" class="mr-2" text><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="SetMoveCorpLog()" class="ml-2" dark><v-icon class="mr-1">save</v-icon>저장</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <SearchCorp ref="SearchCorpRef" @GetCorpInfo="GetCorpInfo"/>
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";

import Util from "../Util.js";
import SearchCorp from "../views/SearchCorp.vue";

export default {
  components: {
    SearchCorp,
  },
  data: () => ({
    dialog : false,
    loading : false,
    NowSelFile : null,
    
    editedIndex : -1,
    sNowPath : "",
    cCorpNm : "",
    editedItem : {
      cReqId : "",
      cLocal : "",
      cNewCorpId : "",
      cMoveLocal : "",
      cMoveCorpNmKor : "",
      cMoveCorpNmEng : "",
      cChangeReason : "",
      cFileB64Data : "",
      cFileNm : "",
      cFileId : "",
    },
  }),
  computed: {
    ...mapState(["CustomInfo","zFileType","FMaxSize3"]),
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy(){
    window.URL.revokeObjectURL(this.sNowPath)
  },


  methods : {
    async ShowDialog(item,index){
      this.dialog = true
      this.editedIndex = index
      // this.editedItem = JSON.parse(JSON.stringify(item));

      this.editedItem = Object.assign({
        cReqId : item.cReqId,
        cNewCorpId : item.cNewCorpId,
        cMoveLocal : item.cMoveLocal,
        cMoveCorpNmKor : item.cMoveCorpNmKor,
        cMoveCorpNmEng : item.cMoveCorpNmEng,
        cChangeReason : item.cChangeReason,
        cFileNm : item.cFileNm.length > 10 ? item.cFileNm.substring(0,8) + " ..." : item.cFileNm,
        cFileId : item.cFileId,
        // cThumbnailPath : item.cThumbnailPath,
      })

      this.cCorpNm = this.editedItem.cMoveLocal == "Y" ? this.editedItem.cMoveCorpNmKor : this.editedItem.cMoveCorpNmEng
      this.NowSelFile = null

      // this.sNowPath = BasicInfo.FILE_API + this.editedItem.cThumbnailPath
      this.sNowPath = await this.ChangeBlobData1(true,item.cFileId,this.editedItem.cFileB64Data)

      setTimeout(() => {
        window.URL.revokeObjectURL(this.sNowPath)
      }, 200);


      setTimeout(() => {
        var element =  document.getElementById("Top_Scroll");
        element.scrollIntoView({behavior : "smooth"})
      }, 10);      
    },

    async ChangeBlobData1(RefreshData,FileId,b64Data) {
      let blob = null

      if (b64Data == "" || RefreshData) {
        var res = await this.DownloadAuthFile(FileId)
        if (res.data.ResultCd == "00") {
          try {
            this.editedItem.cFileB64Data = res.data.Result[0].data
            
            const response = await fetch(res.data.Result[0].data);
            blob = await response.blob();
          } catch (error) {
            console.error(error);
            return ""
          }

          if (blob) {
            return URL.createObjectURL(blob)
          } else {
            return ""
          }

        } else {
          return ""
        }
      } else {
        try {
          const response = await fetch(b64Data);
          blob = await response.blob();
        } catch (error) {
          console.error(error);
          return ""
        }

        if (blob) {
          return URL.createObjectURL(blob)
        } else {
          return ""
        }
      }
    },

    DownloadAuthFile(FileId) {
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        FileId : FileId,
      }
      
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_AUTH_FILE_API, posData , {
          headers: {
            "Authorization": this.CustomInfo.Token,
            'Content-Type': 'application/json',
          }
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          resolve(null);
          EventBus.$emit("onFileBus",err);
        })
      ));
    },

    SearchCorpDialog() {
      this.$refs.SearchCorpRef.Open("MoveCorp",this.cCorpNm);
    },

    GetCorpInfo(Data) {
      if (Data != undefined) {
        this.editedItem = Object.assign({
          cNewCorpId : Data.cCorpId,
          cMoveCorpNmKor : Data.cCorpNmKor,
          cMoveCorpNmEng : Data.cCorpNmEng,
          cMoveLocal : Data.cLocal,
        })

        this.cCorpNm = Data.cLocal == "Y" ? Data.cCorpNmKor : Data.cCorpNmEng
      }
    },

    async onSelFile(NowSelFile) {
      let bFileType = false

      if (NowSelFile != null)  {
        if (NowSelFile.size > this.FMaxSize3)  {
          this.sNowPath = ""

          setTimeout(() => {
            this.NowSelFile = null;
          }, 300);
          EventBus.$emit("onShowMsgBox","첨부하신 파일의 용량의 크기를 확인하여 주세요.","첨부하실수 있는 파일의 크기는 최대 10MB까지 입니다.");
          return
        }

        for ( let i in this.zFileType) {
          if (this.zFileType[i] == NowSelFile.type) {
            bFileType =  true;
            break
          }
        }
      } else {
        bFileType = true
      }

      if (!bFileType) {
        setTimeout(() => {
          this.NowSelFile = null;
        }, 300);
        EventBus.$emit("onShowMsgBox","첨부하신 파일의 형식을 확인하여 주세요.","첨부하실수 있는 파일의 형식은 JPG,JPEG,PNG,GIF 입니다.");
        return
      }

      this.loading = true
      const reader = new FileReader

      reader.onload = e => {
        var imageData = e.target.result;
        this.sNowPath = imageData;
        this.loading = false;
      }

      try {
        this.loading = false;
        reader.readAsDataURL(NowSelFile)
      }
      catch (error) {
        this.sNowPath = await this.ChangeBlobData1(false,this.editedItem.cFileId,this.editedItem.cFileB64Data)

        setTimeout(() => {
          window.URL.revokeObjectURL(this.sNowPath)
        }, 200);

        this.loading = false;
        EventBus.$emit("onFileBus", true,""+error);
        // EventBus.$emit("onShowMsg", true,""+error);
      }
    },

    bSendSvrFile(){
      var d = new Date();
      var Year = d.getFullYear(); 
      
      var fileName = this.NowSelFile.name;
      var Extend = Util.getExtension(fileName).toUpperCase();
      var sFileTypeId = Util.sGetId(Util.sGetFileType(this.NowSelFile.type));
        
      let formData = new FormData();
      formData.append('uploadauthfile', this.NowSelFile);
      return new Promise((resolve) => (
        axios.post(process.env.VUE_APP_UIL_API + "UploadAuthFile?PublicFile=Y&Year="+Year+"&FileNm="+fileName+"&Extend="+Extend+"&MimeType="+this.NowSelFile.type+"&Size="+this.NowSelFile.size+"&FileTypeId="+sFileTypeId+"&CustomId="+this.CustomInfo.CustomId+"&SiteId="+this.CustomInfo.SiteId,
                formData,
                {
                headers: {
                  // "Authorization" : this.CustomInfo.Token,
                  'Content-Type' : 'multipart/form-data',
                }
              }
            )
            .then(res => {
              resolve(res);
            })
            .catch(err =>{
              resolve(null);
              EventBus.$emit("onShowMsg",true, "파일저장에 실패하였습니다. 관리자에게 문의 바랍니다." + err)
          })
      ));
    },

    async SetMoveCorpLog(){
      if (this.editedItem.cNewCorpId == ""){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "변경 된 업체를 입력(선택)하여 주세요.");
        return
      }
      
      if (this.editedItem.cChangeReason == ""){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 누락되었습니다.", "변경 사유를 입력하여 주세요.");
        return
      }

      if (this.editedItem.cChangeReason.length > 100){
        EventBus.$emit("onShowMsgBox", "필수입력 사항이 정확하게 입력하여 주세요.", "변경 사유는 100자 이내로 입력하여 주세요.");
        return
      }
      
      this.loading = true;

      if (this.NowSelFile != null) {
        var res = await this.bSendSvrFile();
        if (res.data.ResultCd == "00") {
          this.editedItem.cFileId = res.data.FileId;
          this.editedItem.cFileNm = res.data.FileNm;
          // this.editedItem.cThumbnailPath = res.data.Path;
        } else {
          EventBus.$emit("onShowMsg",true, "파일 저장에 실패하였습니다. 관리자에게 문의 바랍니다.");
          this.loading = false;
          return;
        }        
      }

      var posData = {
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        CorpId : this.CustomInfo.CorpId,
        NewCorpId : this.editedItem.cNewCorpId,
        ChangeReason : this.editedItem.cChangeReason,
        ReqId  : this.editedItem.cReqId,
        FileId  : this.editedItem.cFileId,
        FileNm  : this.editedItem.cFileNm,
        // ThumbnailPath  : this.editedItem.cThumbnailPath,
        MoveCorpNmEng  : this.editedItem.cMoveCorpNmEng,
        MoveCorpNmKor  : this.editedItem.cMoveCorpNmKor,
        MoveLocal  : this.editedItem.cMoveLocal,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "SetMoveCorpLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            // res.data.Result[0].sNum = this.editedIndex + 1;
            EventBus.$emit("onShowMsg",false,  "수정이 완료되었습니다.");
            this.$emit("ChangeReq", this.editedItem, this.editedIndex)
            this.dialog = false;
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd == "04") {
            EventBus.$emit("onShowMsgBox","관리자가 결재 내역을 바꾸었습니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd == "06") {
            this.$store.dispatch('logout',"DelCustomId");
            EventBus.$emit("onShowMsgBox", "삭제 처리된 아이디 입니다.", "로그인 화면으로 이동합니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>